import { Wifi } from 'lucide-react';

import { useDevice } from '@/store/device';
import { ConnectivityCard } from '@/components/network/ConnectivityCard';
import { ProxyCard } from '@/components/network/ProxyCard';
import { DnsCard } from '@/components/network/DnsCard';

/**
 * Network 页：把抓包/调试时最高频的三类网络操作收口到一个独立 tab，
 * 避免用户在 Commands 里大海捞针。
 *
 * Layout: 单列在窄屏（< xl），双列从 xl 起。Connectivity 总是占 1 列；
 * Proxy 占整行（最复杂），DNS 占 1 列。
 */
export default function Network() {
  const { serial, isOnline, currentState } = useDevice();

  return (
    <div className="space-y-4">
      <header className="flex flex-wrap items-end justify-between gap-2">
        <div>
          <div className="flex items-center gap-2">
            <Wifi className="h-5 w-5 text-accent" />
            <h1 className="text-lg font-semibold text-ink">网络 · Network</h1>
          </div>
          <p className="mt-1 text-[12px] text-ink-muted">
            WiFi / 移动数据 / 飞行模式 · HTTP 代理 + Charles/mitm/Whistle 一键预设 · Private DNS
            （Android 9+）。
          </p>
        </div>
        <DeviceBadge serial={serial} state={currentState} online={isOnline} />
      </header>

      {!serial && (
        <div className="card-pad text-sm text-ink-muted">
          请先在右上角选择一个在线设备。Network 面板的所有操作都依赖一个 selected serial。
        </div>
      )}

      <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
        <div className="xl:col-span-1">
          <ConnectivityCard serial={serial} />
        </div>
        <div className="xl:col-span-2">
          <ProxyCard serial={serial} />
        </div>
        <div className="xl:col-span-1">
          <DnsCard serial={serial} />
        </div>
      </div>
    </div>
  );
}

function DeviceBadge({
  serial,
  state,
  online,
}: {
  serial?: string;
  state: string;
  online: boolean;
}) {
  if (!serial) return <span className="badge">未选择设备</span>;
  return (
    <span className={`badge ${online ? 'border-accent/40 bg-accent-soft text-accent' : ''}`}>
      <span className="font-mono">{serial}</span>
      <span className="ml-1.5 text-ink-muted">· {state}</span>
    </span>
  );
}
